<template>
    <div class="job__openings">
        <a class="more__details" :href="'/careers/' + this.current_job.slug">
            <p>MORE DETAILS</p>
        </a>
        <div class="info" @mouseenter="slideIn()" @mouseleave="slideOut()">
            <p class="role">ROLE:</p>
            <p class="absolute__text">WE ARE LOOKING FOR</p>
            <div class="hr-line"></div>
            <p class="job__title">
                {{ this.current_job.name }}
            </p>
            <div class="job__description" v-html="this.current_job.short_description"></div>
            <div class="hr-line"></div>
            <div class="progress"><div id="progressbar_jobs" class="in animate"></div></div>
        </div>
        <div class="image" v-bind:style="this.current_job.image_styles">
        </div>
        <div class="span_bg" id="slide_in_bg" @mouseenter="slideIn()">
            <a :href="'/careers/' + this.current_job.slug">Read more info...</a>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                current_job: {},
                slider_index: 0,
                autoplay_on: true,
                JOBS_AUTOPLAY_TIMER: 10000,
                JOBS_TIMEOUT: null,
            }
        },
        props: ['careers'],
        mounted(){
            this.careers.push({
                name: "General Application",
                short_description:  "We are always looking to upgrade our team - feel free to contact us!",
                image_styles: {
                    background: "url('/images/generalapplication.webp')",
                    backgroundRepeat: 'no-repeat',
                    // backgroundAttachment: 'fixed',
                    backgroundPosition: 'center',
                    backgroundSize: 'cover'
                },
                slug: ""
            })

            this.setCurrentJob(0);
        },
        methods: {
            changeJob(direction){
                if(this.careers.length > 1){
                    if(direction === -1){
                        if(this.slider_index === 0){
                            this.setCurrentJob(this.careers.length -1);
                        } else {
                            this.setCurrentJob(this.slider_index - 1);
                        }
                    } else {
                        if(this.slider_index == this.careers.length - 1){
                            this.setCurrentJob(0);
                        } else {
                            this.setCurrentJob(this.slider_index + 1);
                        }
                    }
                }
                
            },

            setCurrentJob(index){
                this.slider_index = index;
                this.current_job = this.careers[index];
                if(this.current_job.name !== "General Application"){
                    this.current_job.image_styles = {
                        background: "url('/image/careers/" + this.current_job.featured_image + "')",
                        backgroundRepeat: 'no-repeat',
                        // backgroundAttachment: 'fixed',
                        backgroundPosition: 'center',
                        backgroundSize: 'cover'
                    }
                }
                

                // autoplay of video and next project switch
                if(this.autoplay_on){
                    if(this.careers.length > 1){
                        this.setAutoPlayTimeouts();
                    }
                } else {
                    this.clearAutoPlayTimeouts();
                    this.restartProgressBar();
                }
            },

            setAutoPlayTimeouts(){
                this.JOBS_TIMEOUT = setTimeout(() => {
                    this.restartProgressBar();
                    this.changeJob(1, false);

                }, this.JOBS_AUTOPLAY_TIMER);

            },

            clearAutoPlayTimeouts(){
                clearTimeout(this.JOBS_TIMEOUT);
            },

            restartProgressBar(){
                const bar = document.getElementById('progressbar_jobs');
                if(bar.classList.contains('animate')) {
                    bar.style.animation = 'none';
                    bar.offsetHeight; /* trigger reflow */
                    bar.style.animation = null; 
                    bar.classList.remove('animate'); 
                    bar.classList.add('animate');
                };
            },

            slideIn(){
                if(window.innerWidth < 837) return;
                const bg = document.getElementById('slide_in_bg');
                if(!bg.classList.contains('visible')) bg.classList.add('visible');
            },

            slideOut(){
                if(window.innerWidth < 837) return;
                const bg = document.getElementById('slide_in_bg');
                if(bg.classList.contains('visible')) bg.classList.remove('visible');
            }

            
        }
    }
</script>
<style lang="scss" scoped>
    .job__openings{
        width: 623px;
        height: 300px;
        display: flex;
        flex-direction: row;
        margin-top: auto;
        margin-bottom: auto;
        position: relative;
        filter: drop-shadow(0px 6px 6px rgba(0, 0, 0, 0.25));

        .more__details{
            display: none;
            width: 100%;
            height: 31px;

            border: 1px solid #ED1163;
            text-decoration: none;

            p{
                font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                font-style: normal;
                // font-weight: 700;
                font-size: 12px;
                line-height: 33px;
                text-align: center;
                margin: 0;

                color: #FFFFFF;
            }
        }

        .info{
            display: block;
            // background: url('/images/careers/job_overlay.webp') no-repeat;
            background: linear-gradient(180deg, #221035 0%, #000000 100%);
            // background-size: cover;
            width: 327px;
            max-height: 300px;
            padding: 30px;
            position: relative;

            .absolute__text{
                position: absolute;
                top: -40px;

                font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                font-style: normal;
                // font-weight: 700;
                font-size: 14px;
                line-height: 17px;
                /* identical to box height */

                text-transform: uppercase;

                color: #ED1163;
            }

            .role{
                font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                font-style: normal;
                // font-weight: 700;
                font-size: 18px;
                line-height: 17px;
                /* or 17px */

                color: #ED1163;
                margin: 0;
                margin-bottom: 11px;
            }

            .job__title{
                font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                font-style: normal;
                font-weight: 400;
                font-size: 26px;
                line-height: 23px;
                /* or 23px */
                color: #FFFFFF;
                margin-top: 20px;
                margin-bottom: 20px;
            }

            .job__description{
                font-family: 'DIN Next LT Pro UltraLight', Tahoma, Verdana, sans-serif;
                font-style: normal;
                // font-weight: 300;
                font-size: 16px;
                // line-height: 19px;
                line-height: 18px;
                /* or 19px */

                color: #FFFFFF;
                // height: 127px;
                height: 125px;
                overflow-y: hidden;
            }

            .hr-line{
                width: 100%;
                height: 1px;
                background: #ED1163;
            }
        }

        .image{
            display: block;
            background-size: cover;
            max-width: 296px;
            min-width: 296px;
            height: 300px;

            transition: background-image 1s ease-in-out;
        }

        .span_bg{
            background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
            height: 100%;
            width: 0;
            transition: all .3s ease-in-out;
            margin-top: auto;
            margin-bottom: 0;
            opacity: 1;
            position: absolute;
            bottom: 0;
            left: 327px;
            overflow: hidden;

            &.visible{
                width: calc(296px);
                bottom: 0;
                opacity: 1;
            }

            a{
                font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                font-style: normal;
                // font-weight: 700;
                font-size: 20px;
                line-height: 18px;
                /* or 18px */

                color: #FFFFFF;
                text-decoration: none;
                position: absolute;
                top: 50%; right: 50%;
                transform: translate(50%,-50%);

                width: 150px;
            }
            // z-index: ;
        }

        .progress{
            // border: 1px solid #666;
            height: 3px;
            width: 100%;
            position: absolute;
            bottom: 0;
            left: 0;
            
            .in {
                height: 100%;
                background-color: #ED1163;
                width: 0%;

                // start the animation
                &.animate{
                    animation: fill 10s linear;
                }
            }

            @keyframes fill {
                0% {
                    width: 0%;
                }
                100% {
                    width: 100%;
                }
            }
        }
    }

    @media screen and (max-width: 836px) {

        .job__openings{
            flex-direction: column-reverse;
            // width: calc(100% - 42px);
            width: 100%;
            margin-left: auto;
            margin-right: auto;
            height: 440px;

            .more__details{
                display: block;
                width: calc(100% - 1px);
            }

            .info{
                height: 181px;
                padding: 0;
                width: 100%;

                background: #212121;

                .absolute__text{
                    display: none;
                }

                .role{
                    margin-left: 11px;
                    margin-top: 11px;
                }

                .job__title{
                    margin-left: 11px;
                }

                .job__description{
                    // margin-left: 11px;
                    height: 71px;
                    overflow: hidden;

                    padding: 0 11px;
                    margin-bottom: 11px;
                }

                .hr-line{
                    display: none;
                }
            }

            .image{
                min-height: 180px;
                width: 100%;
                max-width: initial;
                min-width: initial;

                .absolute__text{
                    display: none;
                }
            }
        }

    }
</style>